import React from 'react';
import Cookies from 'js-cookie';
import Navbar from './navbar';
import Footer from './footer';
import { Link } from 'react-router-dom';

const CookiePolicyPage = () => {
  const consent = Cookies.get('cookie_consent');
  const consentId = Cookies.get('cookie_consent_id');
  const consentDate = Cookies.get('cookie_consent_date');
  const preferencesCookie = Cookies.get('cookie_preferences');

  // Парсим JSON из 'cookie_preferences'
  let preferences = {};
  if (preferencesCookie) {
    try {
      preferences = JSON.parse(preferencesCookie);
    } catch (error) {
      preferences = {};
    }
  }

  // Определяем текущее состояние
  let currentState = 'Unknown';
  if (consent === 'all') {
    currentState = 'Allow all';
  } else if (consent === 'necessary') {
    currentState = 'Necessary only';
  } else if (consent === 'custom') {
    currentState = 'Custom settings';
  }

  // Преобразуем дату согласия в удобочитаемый формат
  const formattedDate = consentDate
    ? new Date(consentDate).toLocaleString()
    : 'No date';

  // При клике на "Change your consent" — диспатчим событие, которое поймает CookieConsentModal
  const handleChangeConsent = () => {
    window.dispatchEvent(
      new CustomEvent('openConsentModal', {
        detail: { showCustomize: true },
      })
    );
  };

  // Полный отказ (withdraw) — ставим "necessary"
  const handleWithdrawConsent = () => {
    Cookies.set('cookie_consent', 'necessary', { expires: 365 });
    Cookies.set(
      'cookie_preferences',
      JSON.stringify({
        necessary: true,
        analytics: false,
        marketing: false,
      }),
      { expires: 365 }
    );
    window.location.reload();
  };

  return (
    <>
      <Navbar />

      <section className="relative table w-full py-36 bg-[url('../../assets/images/bg/bg1.svg')] bg-bottom bg-no-repeat">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900"></div>
        <div className="container">
          <div className="grid grid-cols-1 pb-8 text-center mt-10">
            <h3 className="md:text-3xl text-2xl md:leading-snug tracking-wide leading-snug font-medium text-white">
              Cookie Declaration
            </h3>
          </div>
        </div>
        <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
          <ul className="breadcrumb tracking-[0.5px] breadcrumb-light mb-0 inline-block">
            <li className="inline breadcrumb-item text-[15px] font-semibold duration-500 ease-in-out text-white/50 hover:text-white">
              <Link to="/">NIFTY</Link>
            </li>
            <li className="inline breadcrumb-item text-[15px] font-semibold duration-500 ease-in-out text-white" aria-current="page">
              Cookie Declaration
            </li>
          </ul>
        </div>
      </section>
      <div className="relative">
        <div className="shape absolute start-0 end-0 sm:-bottom-px -bottom-[2px] overflow-hidden z-1 text-white dark:text-slate-900">
          <svg className="w-full h-auto" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
          </svg>
        </div>
      </div>

      <section className="relative md:py-24 py-16">
        <div className="container">
          <div className="md:flex justify-center">
            <div className="md:w-3/4">
              <p className="mb-2">This website uses cookies.</p>
              <p className="mb-2">
                Essential cookies are set automatically. Optional cookies can be adjusted to your preferences.
              </p>
              <p className="mb-2">
                For more information about our cookie practices please visit our{' '}
                <Link
                  to="/privacy"
                  className="underline text-violet-600 hover:text-violet-500"
                >
                  Privacy Policy
                </Link>

                 {' '}or contact us at{' '}
                <a href="mailto:info@nifty-art.com" className="text-violet-600 underline">
                  info@nifty-art.com
                </a>.
              </p>

              <p className="mb-2">Your consent applies to the following domains: nifty-art.com</p>

              <p className="mb-2">
                Your current state: <span className="font-medium">{currentState}</span>
              </p>
              {consentId && (
                <p className="mb-2">
                  Your consent ID: <span className="font-medium">{consentId}</span>
                </p>
              )}
              <p className="mb-2">
                Consent date: <span className="font-medium">{formattedDate}</span>
              </p>

              <div className="flex gap-4 mb-4 mt-4">
                <button
                  onClick={handleChangeConsent}
                  className="text-sm text-violet-600 underline hover:no-underline"
                >
                  Change your consent
                </button>
                <button
                  onClick={handleWithdrawConsent}
                  className="text-sm text-violet-600 underline hover:no-underline"
                >
                  Withdraw your consent
                </button>
              </div>

              <p className="mb-4">
                Cookie declaration last updated on <span className="font-medium">20.01.2025</span>
              </p>

              <h2 className="text-xl font-semibold mb-2">Necessary (1)</h2>
              <p className="mb-2">
                Necessary cookies help make a website usable by enabling basic functions like page navigation and
                access to secure areas of the website. The website cannot function properly without these cookies.
              </p>

              <div className="overflow-x-auto">
                <table className="w-full mb-8 border text-sm border-slate-200 dark:border-slate-700">
                  <thead>
                    <tr className="border-b bg-gray-50 dark:bg-slate-800">
                      <th className="p-2 text-left">Name</th>
                      <th className="p-2 text-left">Provider</th>
                      <th className="p-2 text-left">Purpose</th>
                      <th className="p-2 text-left">Max Duration</th>
                      <th className="p-2 text-left">Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b">
                      <td className="p-2">CookieConsent</td>
                      <td className="p-2">nifty-art.com</td>
                      <td className="p-2">
                        Stores the user's cookie consent state for the current domain
                      </td>
                      <td className="p-2">1 year</td>
                      <td className="p-2">HTTP Cookie</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h2 className="text-xl font-semibold mb-2">Statistics (2)</h2>
              <p className="mb-2">
                Statistic cookies help website owners to understand how visitors interact with websites by
                collecting and reporting information anonymously.
              </p>

              <div className="overflow-x-auto">
                <table className="w-full mb-4 border text-sm border-slate-200 dark:border-slate-700">
                  <thead>
                    <tr className="border-b bg-gray-50 dark:bg-slate-800">
                      <th className="p-2 text-left">Name</th>
                      <th className="p-2 text-left">Provider</th>
                      <th className="p-2 text-left">Purpose</th>
                      <th className="p-2 text-left">Max Duration</th>
                      <th className="p-2 text-left">Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b">
                      <td className="p-2">_ga</td>
                      <td className="p-2">Google</td>
                      <td className="p-2">
                        Used to send data to Google Analytics about the visitor's device and behavior.
                        Tracks the visitor across devices and marketing channels.
                      </td>
                      <td className="p-2">2 years</td>
                      <td className="p-2">HTTP Cookie</td>
                    </tr>
                    <tr>
                      <td className="p-2">_ga_#</td>
                      <td className="p-2">Google</td>
                      <td className="p-2">
                        Used to send data to Google Analytics about the visitor's device and behavior.
                        Tracks the visitor across devices and marketing channels.
                      </td>
                      <td className="p-2">2 years</td>
                      <td className="p-2">HTTP Cookie</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default CookiePolicyPage;
